import Swiper from 'swiper/bundle';

var $ = jQuery;

$(document).ready(function ($) {
    // Initialize Similar Recipes Slider
    if ($('.similar-recipes-slider').length) {
        new Swiper('.similar-recipes-slider', {
            slidesPerView: 1.1,
            spaceBetween: 8,
            centeredSlides: true,
            loop: false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                    centeredSlides: false,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                    centeredSlides: false,
                }
            }
        });
    }
});

// Debounce function to optimize resize event
function debounce(func, delay) {
    let timeout;
    return function () {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, arguments), delay);
    };
}

function adjustRecipeCardHeight() {
    const cards = document.querySelectorAll('.recipe-card');
    let maxHeight = 0;

    cards.forEach(card => (card.style.height = 'auto'));

    cards.forEach(card => {
        maxHeight = Math.max(maxHeight, card.offsetHeight);
    });

    cards.forEach(card => {
        card.style.height = `${maxHeight}px`;
    });
}

// Initialize Recipes Carousel Slider when DOM is ready
document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper !== 'undefined' && document.querySelector('.recipes-carousel-slider')) {
        new Swiper('.recipes-carousel-slider', {
            slidesPerView: 1.2,
            spaceBetween: 16,
            centeredSlides: false,
            loop: false,
            pagination: {
                el: '.blk-recipes-carousel .swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.blk-recipes-carousel .swiper-button-next',
                prevEl: '.blk-recipes-carousel .swiper-button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 1.8,
                },
                1024: {
                    slidesPerView: 2.8,
                }
            },
            on: {
                init: adjustRecipeCardHeight,
                resize: adjustRecipeCardHeight
            }
        });
    }

    // Adjust heights only if necessary
    if ($('.similar-recipes').length > 0 || $('.blk-recipes-carousel').length > 0) {
        window.addEventListener('load', adjustRecipeCardHeight);
        window.addEventListener('resize', debounce(adjustRecipeCardHeight, 300));
    }
});
